export enum EContext {
  MainMenu = 'ContextMainMenu',
  InMatch = 'ContextInMatch',
  RteScene = 'ContextRteScene',
  ReplayScene = 'ContextReplayScene',
  Assembly = 'ContextAssemblyScene'
}

export const sceneContexts = [EContext.MainMenu, EContext.InMatch, EContext.RteScene, EContext.ReplayScene, EContext.Assembly];
